import { EDatasetConnector } from "@/types/dataset";
import { getBasePath } from "@/utils/basePath";

export enum ProductKeyEnum {
  INTELLIGENCE = "intelligence",
  TARGETIN = "targetin"
}
export type ProductKey = ProductKeyEnum;

export type Product = {
  key: ProductKey;
  label: string;
  url: string;
  /** Client id the subscription uses for this product */
  clientId: EDatasetConnector;
};

export const DEFAULT_PRODUCT: ProductKey = ProductKeyEnum.INTELLIGENCE;

// Every product is served from the current origin, so partner subdomains keep
// their own host. Targetin always lives under `/targetin-v2/`.
export const PRODUCTS: Product[] = [
  {
    key: ProductKeyEnum.TARGETIN,
    label: "Targetin",
    clientId: EDatasetConnector.TARGETIN,
    url: `${globalThis.location.origin}/targetin-v2/`
  },
  {
    key: ProductKeyEnum.INTELLIGENCE,
    label: "Intelligence",
    clientId: EDatasetConnector.LI,
    url: `${globalThis.location.origin}${getBasePath()}`
  }
];
